import { Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";

interface SSOMessageProps {
    consentSSOMessageCallback: () => void;
}

export default function SSOMessage(props: SSOMessageProps) {

  const postConsent = () => {
    props.consentSSOMessageCallback();
  };

  return (
    <>
    <Typography variant="h6">Consentement SSO</Typography>
    <br />
    <Typography variant="body1">
      L'application permettra les fonctionnalités suivantes : <br /><br />
      - D'autres collaborateurs pourront créer des activités pour vous. <br /><br />
      - Vous pourrez créer des activités pour d'autres collaborateurs. <br /><br />
    </Typography>
    <br />
    <br />
    <Button variant="contained" color="primary" onClick={() => postConsent()}>
      Consentir
    </Button>
    </>
  );
}